(function () {
	'use strict';
	$(document).ready(function () {
		function getFilterProjectsAndCount(projects, params) {
			const filteredProjects = projects.filter(project =>
				params.every(param => {
					if (param.outerParam === '') return true;

					if (Array.isArray(project[param.innerParam])) {
						return project[param.innerParam].includes(param.outerParam);
					} else {
						return +project[param.innerParam] === param.outerParam;
					}
				}),
			);

			const count = filteredProjects.length;
			const joinedContent = filteredProjects.map(p => p.windowContent).join('');

			return { projects: filteredProjects, count, joinedContent };
		}

		async function initMap() {
			// Request needed libraries.
			const { Map } = await google.maps.importLibrary('maps');
			const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
				'marker',
			);
			const centerPlace = { lat: 49.024, lng: 18.887 };
			const zoom = 5;
			const map = new google.maps.Map(document.getElementById('map'), {
				zoom: zoom,
				center: centerPlace,
				mapId: 'c916beebd19ee385',
			});

			const filterProjects = document.querySelector('.filter-projects');
			const filterProjectsWrapper = document.querySelector('.filter-projects-wrapper');
			const filterTrigger = document.getElementById('filter-form-search');
			const clearTrigger = document.getElementById('filter-form-clear');
			const countryLocationSelect = document.getElementById('projects-location');
			const serviceSelect = document.getElementById('projects-service');
			const buildingType = document.getElementById('projects-building-type');
			const delay = 250;

			function renderMarkers(projects) {
				return projects.map((position) => {
					const pinGlyph = new google.maps.marker.PinElement({
						glyphColor: 'white',
					});

					const marker = new google.maps.marker.AdvancedMarkerElement({
						position,
						content: pinGlyph.element,
					});

					marker.addListener('click', () => {
						const filterParam = position.state_id ? 'state_id' : 'country_id';
						const filteredProjects = getFilterProjectsAndCount(projects, [
							{
								innerParam: filterParam,
								outerParam: +position[filterParam],
							},
						]);
						filterProjects.innerHTML = filteredProjects.joinedContent;
						filterProjectsWrapper.querySelector('.count').innerHTML = filteredProjects.count;
						$('.filter-projects-wrapper').slideDown();
						filterProjectsWrapper?.classList.add('loading');
						map.panTo(position);

						setTimeout(function () {
							const activeElement = filterProjects.querySelector(`[data-id="${position.id}"]`);
							activeElement?.classList.add('active');
							activeElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

							filterProjectsWrapper?.classList.remove('loading');
						}, delay);
					});

					return marker;
				});
			}

			let markers = renderMarkers(projects);

			filterTrigger?.addEventListener('click', () => {
				const stateLocationSelect = document.getElementById('projects-voivodeship');
				const cityLocationSelect = document.getElementById('projects-city');

				let filterParam = 'country_id';
				let locationChoice = countryLocationSelect?.value;
				if (stateLocationSelect && stateLocationSelect.value) {
					filterParam = 'state_id';
					locationChoice = stateLocationSelect?.value;
				}
				if (cityLocationSelect && cityLocationSelect.value) {
					filterParam = 'city_id';
					locationChoice = cityLocationSelect?.value;
				}


				const filters = [];
				if (locationChoice) {
					filters.push({
						innerParam: filterParam,
						outerParam: +locationChoice,
					});
				}
				if (serviceSelect?.value) {
					filters.push({
						innerParam: 'service_id',
						outerParam: +serviceSelect.value,
					});
				}
				if (buildingType?.value) {
					filters.push({
						innerParam: 'building_type_id',
						outerParam: +buildingType.value,
					});
				}

				const filteredProjects = getFilterProjectsAndCount(projects, [
					...filters,
				]);
				filterProjects.innerHTML = filteredProjects.joinedContent;
				filterProjectsWrapper.querySelector('.count').innerHTML = filteredProjects.count;
				cluster.clearMarkers();
				markers = renderMarkers(filteredProjects.projects);
				$('.filter-projects-wrapper').slideDown();
				filterProjectsWrapper?.classList.add('loading');
				setTimeout(function () {
					if (filteredProjects.projects.length > 0) {
						map.panTo({ lat: filteredProjects.projects[0].lat, lng: filteredProjects.projects[0].lng });
					}
					cluster.addMarkers(markers);
					filterProjectsWrapper?.classList.remove('loading');
				}, delay);
			});

			clearTrigger?.addEventListener('click', () => {
				$('.filter-projects-wrapper').slideUp();
				filterProjects.innerHTML = '';
				cluster.clearMarkers();
				markers = renderMarkers(projects);
				filterProjectsWrapper?.classList.add('loading');
				setTimeout(function () {
					map.zoom = zoom;
					map.panTo(centerPlace);
					cluster.addMarkers(markers);
					filterProjectsWrapper?.classList.remove('loading');
				}, delay);
			});

			const cluster = new markerClusterer.MarkerClusterer({ markers, map });
		}

		if (document.getElementById('map')) initMap().catch(console.error);
	});
}(jQuery));
